import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const InvitesApi = {
    get: (webinarId: string, options?: BaseApiQueryOptions) => apiQueryOptions(['invites', 'get', webinarId], (api) => api.invites.get(webinarId), options),
    invite: (options?: BaseApiMutationOptions<ApiClient['invites']['invite']>) => apiMutationOptions((api) => api.invites.invite, options),
    remove: (options?: BaseApiMutationOptions<ApiClient['invites']['remove']>) => apiMutationOptions((api) => api.invites.remove, options),
    email: (options?: BaseApiMutationOptions<ApiClient['invites']['email']>) => apiMutationOptions((api) => api.invites.email, options),
    emailReminder: (options?: BaseApiMutationOptions<ApiClient['invites']['emailReminder']>) => apiMutationOptions((api) => api.invites.emailReminder, options),
    getSettings: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['invites', 'settings', webinarId], (api) => api.invites.getSettings(webinarId), options),
    updateSettings: (options?: BaseApiMutationOptions<ApiClient['invites']['updateSettings']>) =>
        apiMutationOptions((api) => api.invites.updateSettings, options)
};
